var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
import CategorySubModel from './CategorySubModel';
import * as _ from 'lodash';
var itemImagePlaceholder = 'http://via.placeholder.com/300x225'; // temp
var CategoryModel = /** @class */ (function (_super) {
    __extends(CategoryModel, _super);
    function CategoryModel(data) {
        var _this = _super.call(this, data) || this;
        var hydrated = _super.prototype.useHydrator.call(_this, data);
        _this.id = hydrated.id;
        _this.name = hydrated.name;
        _this.image = hydrated.image;
        _this.isSecret = hydrated.isSecret;
        _this.subCategories = hydrated.subCategories;
        _this.__mc = 'CategoryModel';
        return _this;
    }
    CategoryModel.validateImage = function (baseUrl, url) {
        if (!BaseModel.validType(url, 'string')) {
            return itemImagePlaceholder;
        }
        return "" + baseUrl + url;
    };
    CategoryModel.createSubCategory = function (subCategory) {
        var hydrated = new CategorySubModel(subCategory);
        return hydrated;
    };
    CategoryModel.prototype.available = function () {
        var isSecret = this.isSecret;
        var sectionItems = this.sectionsInCategory();
        if (_.isEmpty(sectionItems)) {
            console.error("category " + this.name + " is missing items");
            return false;
        }
        if (this.id === 'unlisted') {
            return false;
        }
        if (isSecret) {
            return false;
        }
        return true;
    };
    CategoryModel.prototype.firstItemInCategory = function () {
        if (this.subCategories.length < 1) {
            return;
        }
        return this.subCategories[0].firstItemInSection();
    };
    CategoryModel.prototype.sectionsInCategory = function () {
        var itemIds = [];
        this.subCategories.forEach(function (subCategory) {
            var sectionItems = subCategory.itemsInSections();
            itemIds.push(sectionItems);
        });
        itemIds = _.flattenDeep(itemIds);
        return itemIds;
    };
    CategoryModel.prototype.itemIdInCategory = function (_itemId) {
        var itemIds = this.sectionsInCategory();
        var id = _.find(itemIds, function (itemId) {
            return itemId === _itemId;
        });
        return id;
    };
    CategoryModel.validateId = function (id) {
        var validId = id;
        if (id.replace(/\s* /, '') === '') {
            validId = 'unlisted';
        }
        return validId.toLowerCase();
    };
    CategoryModel.prototype.hydrate = function (data) {
        var category = {};
        category['id'] = CategoryModel.validateId(data.name);
        category['name'] = data.name || null;
        category['image'] = CategoryModel.validateImage(data.baseURL, data.img);
        category['isSecret'] = data.is_secret || false;
        category['subCategories'] = data.sub_categories || null;
        var subCategories = category['subCategories'];
        if (subCategories) {
            var createSubCategory = CategoryModel.createSubCategory;
            category['subCategories'] = subCategories.map(createSubCategory);
        }
        return category;
    };
    CategoryModel.prototype.hydrateFromStore = function (data) {
        var category = {};
        category['id'] = CategoryModel.validateId(data.id);
        category['name'] = data.name || null;
        category['image'] = data.image || null;
        category['isSecret'] = data.is_secret || false;
        category['subCategories'] = data.subCategories || null;
        return category;
    };
    return CategoryModel;
}(BaseModel));
export default CategoryModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/CategoryModel.ts
// module id = vE92
// module chunks = 18